import { AuthActions } from "./auth.actions";
import { AuthState } from "./auth.state";

export const initialState: AuthState = {
  apiToken: null,
  isAuthenticated: false,
  user: {
    email: "",
    full_name: ""
  },
  isReset: false,
  error: null
};

export function AuthReducer(state: AuthState = initialState, action) {
  switch (action.type) {
    case AuthActions.SET_AUTHENTICATION:
      return {
        apiToken: action.payload.apiToken,
        isAuthenticated: true,
        user: action.payload.user
      };

    case AuthActions.ME:
      state.isAuthenticated = true;
      state.user = action.payload.user;
      return state;

    case AuthActions.PASSWORD_IS_RESET:
      return {
        isReset: true,
        isAuthenticated: false
      };

    case AuthActions.ERROR:
      return {
        error: action.payload,
        isAuthenticated: false
      };

    case AuthActions.CLEAR_AUTHENTICATION:
      return {
        isAuthenticated: false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/auth/auth.reducer.ts